(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientPicture', PatientPicture);

    PatientPicture.$inject = ['$resource'];

    function PatientPicture ($resource) {
        var resourceUrl =  'api/patient-pictures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
